import { App } from '@capacitor/app';
import { useEffect, useState } from 'react';

export default function useIsAppVisible() {
  const [isAppVisible, setIsAppVisible] = useState<boolean>(true);
  const [isDocumentVisible, setIsDocumentVisible] = useState<boolean>(true);

  useEffect(() => {
    App.addListener('appStateChange', ({ isActive }) => {
      setIsAppVisible(isActive);
    });

    window.addEventListener('focus', () => {
      setIsDocumentVisible(true);
    });

    window.addEventListener('blur', () => {
      setIsDocumentVisible(false);
    });
  }, []);

  return isAppVisible && isDocumentVisible;
}
